import { Injectable } from '@angular/core';
import { normalizeFieldsConfigs } from '../generic-fields/generic-fields';
import { ItemType } from '../models/item';
import { TreeAndItems } from '../root-store/object-tree-store/object-tree.models';
import { forEachTreeNode } from '../utilities/tree';

@Injectable({
  providedIn: 'root'
})
export class ItemService {
  private static itemDialogUrlSchema = /.*\/item\/(.+)-([\d]+).*/

  public static prepareItemTreeData(treeAndItems: TreeAndItems): void {
    // initialize some properties on the items-list
    treeAndItems.items.forEach(i => {
      if (i.fields)
        i.fields = normalizeFieldsConfigs(i.fields as any)

      if (i.bookable === undefined)
        i.bookable = true

      if (i.buildingId)
        i.building = treeAndItems.items.find(i2 => i2.id == i.buildingId)
    })

    // extend tree with item-property
    forEachTreeNode(treeAndItems.tree, (node, parent) => {
      node.parent = parent // set parent reference to allow easy navigation in the tree
      node.grandChildren = node.children?.some(c => c.children && c.children.length > 0) ?? false

      const item = treeAndItems.items.find(i => i.id == node.itemId)
      if (item)
        node.item = item
      else {
        console.warn('item not found', node, 'parent', parent)
        node.item = { id: 0, name: '', urlSlug: '', description: '', type: ItemType.Other, showTip: false, onlyIndividuallySelectable: false }
      }
    })
  }

  public static getItemFromUrl(url: string) {
    let urlMatches = url.match(ItemService.itemDialogUrlSchema)

    if (urlMatches && urlMatches.length >= 3)
      return {
        name: urlMatches[1],
        id: +urlMatches[2],
        slug: urlMatches[1] + '-' + urlMatches[2],
      }

    return null
  }
}
